import axios from 'axios'

const saveTransaction = async function (purchase) {
  console.log('=== saveTransaction (débito veicular) ===')
  console.log('purchase:', purchase)

  const apiUrl = `${process.env.VUE_APP_API_URL}/totem/cadastrarDebitoVeicular.php`

  const username = process.env.VUE_APP_IPAG_API_USER
  const password = process.env.VUE_APP_IPAG_API_PASSWORD
  const basicAuth = btoa(`${username}:${password}`)
  const brlCoin = '957'

  // ---- Cartão (ex: "531372******8026")
  let firstDigits = null
  let lastDigits = null
  if (purchase.cartao) {
    const parts = String(purchase.cartao).split('*')
    firstDigits = parts[0] || null
    lastDigits = (parts[parts.length - 1] || '').replace(/\D/g, '') || null
  }

  // ---- Status
  const isApproved = purchase.status === 'approved' || purchase.sucesso === true
  let statusToSend = 'REJEITADA'
  let code = ''
  let reason = ''

  if (isApproved) {
    statusToSend = 'APROVADA'
    code = '00'
    reason = ''
  } else if (purchase.statusReason && typeof purchase.statusReason === 'string') {
    const reasonData = purchase.statusReason.split('-')
    code = reasonData[0] || ''
    reason = reasonData[1] || purchase.statusReason
  } else {
    code = purchase.codigoRetorno || purchase.codigo || ''
    reason = purchase.motivo || purchase.mensagem || purchase.message || 'Rejeitada'
  }

  // ---- Session Storage
  let dadosPessoais = {}
  let debitosSelecionados = []

  try {
    dadosPessoais = JSON.parse(sessionStorage.getItem('dadosPessoais') || '{}')
    debitosSelecionados = JSON.parse(
      sessionStorage.getItem('debitosSelecionados') || '[]',
    )
  } catch (e) {
    console.warn('Erro ao ler sessionStorage', e)
  }

  if (!Array.isArray(debitosSelecionados) || debitosSelecionados.length === 0) {
    try {
      const consulta = JSON.parse(
        sessionStorage.getItem('dadosConsultaRenavam') || '{}',
      )
      debitosSelecionados = consulta?.dados?._content || []
    } catch (e) {
      debitosSelecionados = []
    }
  }

  const clienteNome = sessionStorage.getItem('clienteNome') || ''
  const placa = sessionStorage.getItem('placaVeiculo') || ''
  const renavam = sessionStorage.getItem('renavamDigitado') || ''
  const estado = sessionStorage.getItem('clienteVeiculo') || ''

  const installmentSelect = sessionStorage.getItem('installmentSelect') || ''
  const parcelas =
    parseInt(installmentSelect, 10) ||
    parseInt(purchase.parcelas, 10) ||
    parseInt(purchase.numParcelas, 10) ||
    1

  const debitos = (Array.isArray(debitosSelecionados) ? debitosSelecionados : []).map(
    (d) => ({
      owner: d.owner || clienteNome,
      value: Number(d.value ?? d.valor ?? 0),
      dueDate: d.dueDate || null,
      renavam: String(d.renavam || renavam).replace(/\D/g, '').padStart(11, '0'),
      taxType: d.taxType || '',
      quotaType: d.quotaType || '',
      segmentCode: d.segmentCode ?? null,
      stateSource: d.stateSource ?? null,
      exerciseYear: d.exerciseYear ?? null,
      licensePlate: d.licensePlate || placa,
      ticketNumber: d.ticketNumber || d.infractionNoticeNumber || null,
      violationCode: d.violationCode ?? null,
      infractionDate: d.infractionDate || null,
      stateAbbreviation: d.stateAbbreviation || estado,
      isLicensingMandatory: d.isLicensingMandatory ?? false,
      issuingAuthorityCode: d.issuingAuthorityCode ?? null,
      violationDescription: d.violationDescription || null,
      infractionNoticeNumber: d.infractionNoticeNumber || null,
    }),
  )


  const valorCentavos = parseInt(purchase.valor ?? purchase.totalAmount ?? 0, 10)

  const payloadData = {
    servico: 'Débito Veicular',
    ec: purchase.cnpj || purchase.ec || '',
    documento: purchase.cnpj || '',
    clienteTelefone: dadosPessoais.phone || '',
    clienteDocumento: (dadosPessoais.cpf || '').replace(/\D/g, ''),
    situacao: statusToSend,
    codigoRetorno: code,
    refuseReason: reason,
    refuse_reason: reason,
    codigoMCC: purchase.mcc || '',
    autorizacao: purchase.autorizacao || purchase.authorizationCode || '',
    moeda: brlCoin,
    tefNsu: purchase.tefNsu || '',
    nsu: purchase.nsu || '',
    valor: valorCentavos,
    parcelas: parcelas,
    cartaoPortador: purchase.cardHolder || purchase.cartaoPortador || '',
    cartaoPrimeirosDigitos: firstDigits,
    cartaoUltimosDigitos: lastDigits,
    bandeira: purchase.bandeira || purchase.cardBrand || '',
    formaPagamento: (purchase.tipoPagamento || 'CREDITO').toUpperCase(),
    formaCaptura: 'pinpad',
    origem: 'TOTEM',
    numeroSerie: purchase.serial || purchase.serialNumber || '',

  
    estado,
    placa,
    renavam,
    proprietario: clienteNome,
    proprietarioDocumento: (dadosPessoais.cpf || '').replace(/\D/g, ''),
    debitos,
  }

  console.log('API URL:', apiUrl)
  console.log('Payload:', payloadData)
  console.log('Qtd debitos:', debitos.length)

  const headers = {
    Authorization: `Basic ${basicAuth}`,
    'Content-Type': 'application/json',
  }

  try {
    const response = await axios.post(apiUrl, payloadData, { headers })
    console.log('saveTransaction sucesso:', response.data)
    return response
  } catch (error) {
    console.error('Erro saveTransaction:', error.response?.status, error.response?.data)
    throw error
  }
}

export { saveTransaction }